import { VatRepercutedLineModelType } from '@teinor/erp/types/company/accounting/vatRepercuted/vatRepercutedLine'
import { ColumnITLayoutTableSchema } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import VatLayout from '../../../../../../../../specificComponents/inputTableLayouts/vat/VatLayout'
import { VatLayoutStepProps } from '../../../../../../../../specificComponents/inputTableLayouts/vat/VatLayout/types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import HeaderVatRepercutedFinished from './HeaderVatRepercutedFinished'
import useSellInvoiceHeaderUrls from '../../../../../../../../utils/hooks/sells/orders/useSellInvoiceHeaderUrls'
import { VatRepercutedStatusInversed } from '@teinor/erp/types/company/accounting/vatRepercuted'

interface VatRepercutedFinishedStepProps extends VatLayoutStepProps { }

const VatRepercutedFinishedStep: React.FC<VatRepercutedFinishedStepProps> = ({ inputTableURLs, completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, userPermissions }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useSellInvoiceHeaderUrls()

    const columns: ColumnITLayoutTableSchema<VatRepercutedLineModelType> = [
        {
            id: 'rowPriceWithoutTax',
            dataKey: 'rowPriceWithoutTax',
            simpleLabel: t('totalWithoutVat', 'Base imponible'),
            label: t('totalWithoutVat', 'Base imponible'),
            component: 'ITDisplayPrice',
            minWidth: 125,
            typeOnChange: 'onChangeTotalsFetch'
        },
        {
            id: 'taxUsed',
            dataKey: 'taxUsed',
            simpleLabel: t('taxUsed', 'Impuesto usado'),
            label: t('taxUsed', 'Impuesto usado'),
            component: 'ITDisplayPercent',
            minWidth: 125,
            typeOnChange: 'onChangeTotalsFetch'
        },
        {
            id: 'vatMoney',
            dataKey: 'vatMoney',
            label: t('vatMoney', 'Impuestos a pagar'),
            simpleLabel: t('vatMoney', 'Impuestos a pagar'),
            component: 'ITDisplayPrice',
            minWidth: 125,
        },
        {
            id: 'taxUsed2',
            dataKey: 'taxUsed2',
            simpleLabel: t('tax2', 'Segundo impuesto'),
            label: t('tax2', 'Segundo impuesto'),
            component: 'ITDisplayPercent',
            minWidth: 125,
            typeOnChange: 'onChangeTotalsFetch'
        },
        {
            id: 'vatMoney2',
            dataKey: 'vatMoney2',
            label: t('vatMoney2', 'Impuestos 2 a pagar'),
            simpleLabel: t('vatMoney2', 'Impuestos 2 a pagar'),
            component: 'ITDisplayPrice',
            minWidth: 125,
        },
        {
            id: 'retentionUsed',
            dataKey: 'retentionUsed',
            simpleLabel: t('retention', 'Retención'),
            label: t('retention', 'Retención'),
            component: 'ITDisplayPercent',
            minWidth: 125,
            typeOnChange: 'onChangeTotalsFetch',
            hideColumnByDefault: true
        },
        {
            id: 'retentionMoney',
            dataKey: 'retentionMoney',
            label:t('retentionMoney', 'Retención a pagar'),
            simpleLabel: t('retentionMoney', 'Retención a pagar'),
            component: 'ITDisplayPrice',
            minWidth: 125,
            hideColumnByDefault: true
        },
        {
            id: 'dua',
            dataKey: 'dua',
            label: t('dua', 'DUA'),
            component: 'ITRectangularInput',
            readOnlyFnc: () => true,
            hideColumnByDefault: true
        },
        {
            id: 'rowPriceWithTax',
            dataKey: 'rowPriceWithTax',
            label: t('priceTotal', 'Precio Total'),
            simpleLabel: t('priceTotal', 'Precio Total'),
            component: 'ITDisplayPrice',
            minWidth: 125,
        }
    ]
    return (
        <VatLayout modelId='VatRepercutedId' name='vatRepercutedFinishedStep' translations={{ headerTitle: t('vatRepercuted', 'IVA Repercutido'), tableTitle: t('vats', 'Impuestos') }} InputTableHeaderChildren={HeaderVatRepercutedFinished} {...{ orderHeaderURLs, columns, inputTableURLs, completeData, setCompleteData, getCompleteData, setTableConfiguration, tableConfiguration, userPermissions, title: t('vatRepercuted', 'IVA Repercutido'), orderStatusDict: VatRepercutedStatusInversed}}>
        </VatLayout>
    )
}

export default VatRepercutedFinishedStep